/** Section exposes N/A checkbox when API sets IsNAAvailable / isNAAvailable. */
export const isSectionNAAvailable = section =>
    !!(section?.IsNAAvailable ?? section?.isNAAvailable)

export const isSectionNASelected = section =>
    !!(
        section?.IsNASelected ??
        section?.isNASelected ??
        section?.IsNA ??
        section?.IsNotApplicable
    )
